// @flow

import type { Merchant } from './types';

export function getPublicIntegrationKey(merchant: Merchant): string {
  return merchant.public_key;
}
